import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Box, Button, FormLabel, Grid, Typography } from '@tq/ui-components';

import { NumberBox } from 'components';
import { ConsultationResponseAnswer } from 'types';
import { useFormatLocaleDate } from 'config/DateFormats/useFormatLocaleDate';

type RpcOtherResponseProps = {
  answer: ConsultationResponseAnswer;
};

export const RpcOtherResponse: React.FC<RpcOtherResponseProps> = ({ answer }) => {
  const { t } = useTranslation('consultation_response');
  const [showAnswer, setShowAnswer] = useState(false);
  const formatLocaleDate = useFormatLocaleDate();
  const handleShowAnswer = () => {
    setShowAnswer(!showAnswer);
  };
  return (
    <>
      <Box backgroundColor={COLOURS.gray[200]} borderRadius={5} p={4} mb={4}>
        <Box display='inline' mr={4}>
          <Button
            float='right'
            display={{ base: 'block', lg: 'none' }}
            size='xs'
            variant='tertiary'
            onClick={handleShowAnswer}
          >
            {!showAnswer && t('show_answer', 'Show answer')}
            {showAnswer && t('hide_answer', 'Hide answer')}
          </Button>
          <strong>{t('question_text', 'Question')}</strong>
        </Box>
        <NumberBox label={answer.questionNumber} />
        <Grid templateColumns={{ base: '1fr', lg: '6fr 1fr' }}>
          <Typography py={2}>{answer.question}</Typography>
          <Button
            display={{ base: 'none', lg: 'block' }}
            size='xs'
            variant='tertiary'
            onClick={handleShowAnswer}
          >
            {!showAnswer && t('show_answer', 'Show answer')}
            {showAnswer && t('hide_answer', 'Hide answer')}
          </Button>
        </Grid>
      </Box>
      {showAnswer && (
        <>
          <Box px={2} mb={4}>
            <strong>{t('answer', 'Answer')}</strong>
            <Typography pt={2}>{answer.answer}</Typography>
          </Box>
          <Box px={4} py={2} mb={4} backgroundColor={COLOURS.gray[200]} borderRadius={5}>
            <FormLabel float='left' pr={1}>
              {t('added_text', 'Added')}:
            </FormLabel>
            {formatLocaleDate(answer.dateCreated)}
          </Box>
        </>
      )}
    </>
  );
};
